import SideBarMain from "../../components/cm/SideBarMain";
import React from "react";
import AppWrapper from "../../components/cm/AppWrapper";
import CaseListList from "../../components/cm/Dashboard/FullPages/CaseList/CaseListList/CaseListList";
import { MainNavBarEnum } from "../../components/cm/SideBarMain/MainNavBarEnum";


export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.SEARCH_CLIENTS}/>}>
      <CaseListList
        customBaseDetailPath={"/client-detail/"}
        customBaseDetailSegment={"/client-info/images"}
      />
    </AppWrapper.WithSidebar>
  );
}
